import Model from "../Model";

class Groupdimensions extends Model{

    buildUrl ({ param }) {
        return ['/filters/getdimesionfilter', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Groupdimensions;